import Vue from 'vue';
import Router from 'vue-router';

import HomeProducts from '@/pages/homeProducts/homeProducts';

import HomeProductsAttractionAndDevelopment from '@/pages/homeProducts/homeProductsAttractionAndDevelopment/homeProductsAttractionAndDevelopment';
import HomeProductsCandidAts from '@/pages/homeProducts/homeProductsCandidAts/homeProductsCandidAts';
import HomeProductsCrs from '@/pages/homeProducts/homeProductsCrs/homeProductsCrs';
import HomeProductsHemisphere from '@/pages/homeProducts/homeProductsHemisphere/homeProductsHemisphere';
import HomeProductsVantage from '@/pages/homeProducts/homeProductsVantage/homeProductsVantage';

import Candidates from '@/pages/candidates/candidates';
import Research from '@/pages/research/research';
import Stories from '@/pages/stories/stories';
import About from '@/pages/about/about';
import ApplyNow from '@/pages/applyNow/applyNow';

import WorkForRare from '@/pages/workForRare/workForRare';
import News from '@/pages/news/news';
import NewsSingle from '@/pages/news/newsSingle';

import NotFound from '@/pages/errorNotFound/notFound';
import InternalServer from '@/pages/errorInternalServer/InternalServer';

import nonEU from '@/pages/nonEU/nonEU';
import RareLegalPageWrapper from '@/pages/legal/RareLegalPageWrapper';

Vue.use(Router);

function buildMetaTags(content, title = '') {
  return {
    title: `Rare | Driving equality through technology ${title && '| '}${title}`,
    metaTags: [
      {
        name: 'description',
        content,
      },
      {
        property: 'og:description',
        content,
      },
      {
        property: 'og:image',
        content: 'https://www.rarerecruitment.co.uk/static/fb-share.png',
      },
    ],
  };
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Root',
      component: HomeProducts,
      meta: buildMetaTags('We’re changing the world. Truly. Take informed decisions. Hire the UK’s best diverse students. Transform your workforce.', 'Home'),
    },
    {
      path: '/products',
      name: 'HomeProducts',
      component: HomeProducts,
      meta: buildMetaTags('Our award-winning, cutting edge products will help you attract, hire and retain a more diverse workforce', 'Products'),
    },

    // START PRODUCTS SUB NAV
    {
      path: '/products/crs',
      name: 'HomeProductsCrs',
      component: HomeProductsCrs,
      meta: buildMetaTags('Contextual Recruitment System | Identify the resilient outperformers who will make your business better.', 'Products | CRS'),
    },
    {
      path: '/products/candid-ats',
      name: 'HomeProductsCandidAts',
      component: HomeProductsCandidAts,
      meta: buildMetaTags('Candid Applicant Tracking System | Beautiful, intuitive interface. Ground-breaking diversity analytics. World-class security.', 'Products | Candid'),
    },
    {
      path: '/products/hemisphere',
      name: 'HomeProductsHemisphere',
      component: HomeProductsHemisphere,
      meta: buildMetaTags('Hemisphere | Combat bias. Reprogramme your brain. Make better decisions.', 'Hemisphere'),
    },
    {
      path: '/products/vantage',
      name: 'HomeProductsVantage',
      component: HomeProductsVantage,
      meta: buildMetaTags('Vantage | Find precisely who you want, when you want.', 'Products : Vantage'),
    },
    {
      path: '/products/attraction-and-development',
      name: 'HomeProductsAttractionAndDevelopment',
      component: HomeProductsAttractionAndDevelopment,
      meta: buildMetaTags('Attraction & Development | Hire the UK’s best diverse students.', 'Products : A & D'),
    },
    // END PRODUCTS SUB NAV

    {
      path: '/candidates',
      name: 'Candidates',
      component: Candidates,
      meta: buildMetaTags('Rare levels the playing field. We help you fulfil your promise through our career guidance and multi award-winning development.', 'Candidates'),
    },
    {
      path: '/candidates/apply-now',
      name: 'ApplyNow',
      component: ApplyNow,
      meta: buildMetaTags('Apply to one of Rare\'s programmes today', 'Candidates | Apply Now'),
    },
    {
      path: '/research',
      alias: '/candidates/research',
      name: 'Research',
      component: Research,
      meta: buildMetaTags('Research | Our original research on race, class and talent drives real change.', 'Research'),
    },
    {
      path: '/stories',
      alias: '/candidates/stories',
      name: 'Stories',
      component: Stories,
      meta: buildMetaTags('“You’ve changed the trajectory of my life”. Read more about Rare’s candidate stories.', 'Stories'),
    },

    {
      path: '/about',
      alias: '/candidates/about',
      name: 'About',
      component: About,
      meta: buildMetaTags('Take informed decisions. Hire the UK’s best diverse students. Transform your workforce.', 'About'),
    },
    {
      path: '/news',
      name: 'News',
      component: News,
      meta: buildMetaTags('Learn about the latest developments in social mobility, diversity, graduate recruitment and more.', 'News'),
    },
    {
      path: '/news/filter/:filterType',
      name: 'NewsFilter',
      component: News,
      meta: buildMetaTags('Learn about the latest developments in social mobility, diversity, graduate recruitment and more.'),
    },

    {
      path: '/news/:article',
      name: 'NewsSingle',
      component: NewsSingle,
      meta: buildMetaTags('Learn about the latest developments in social mobility, diversity, graduate recruitment and more.', 'News | Story'),
    },

    {
      path: '/work-for-rare',
      name: 'WorkForRare',
      component: WorkForRare,
      meta: buildMetaTags('The best people are Rare. We are always looking for the very best people to join us.', 'Work for Rare'),
    },
    {
      path: '/404',
      name: 'NotFound',
      component: NotFound,
      meta: buildMetaTags('Page not found', 'Not found'),
    },
    {
      path: '/500',
      name: 'InternalServer',
      component: InternalServer,
      meta: buildMetaTags('Internal server error', 'Internal server error'),
    },
    {
      path: '/nonEU',
      name: 'nonEU',
      component: nonEU,
      meta: buildMetaTags('Important information for non-EU applicants. Please read before applying to Rare.', 'Non EU'),
    },
    {
      path: '/modern-slavery-statement',
      name: 'ModernSlaveryStatement',
      component: RareLegalPageWrapper,
      props: { header: 'Modern Slavery Statement', content: 'rare-legal-modern-slavery-statement' },
      meta: buildMetaTags('Rare Recruitment Ltd has a zero tolerance approach to any form of modern slavery.', 'Modern Slavery'),
    },
    {
      path: '/website-terms-of-use',
      name: 'WebsiteTermsOfUse',
      component: RareLegalPageWrapper,
      props: { header: 'Website Terms of Use', content: 'rare-legal-website-terms-of-use' },
      meta: buildMetaTags('Rare Recruitment\'s Terms of Use.', 'Terms of Use'),
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: RareLegalPageWrapper,
      props: { header: 'Privacy Policy', content: 'rare-legal-privacy-policy' },
      meta: buildMetaTags('Rare Recruitment\'S Privacy Policy', 'Privacy Policy'),
    },
    {
      path: '/cookie-policy',
      name: 'CookiePolicy',
      component: RareLegalPageWrapper,
      props: { header: 'Cookie Policy', content: 'rare-legal-cookie-policy' },
      meta: buildMetaTags('Rare RecruitmentPrivacy\'S Cookie Policy Policy.', 'Cookie Policy'),
    },
    {
      path: '/accessibility-policy',
      name: 'AccessibilityPolicy',
      component: RareLegalPageWrapper,
      props: { header: 'Accessibility Policy', content: 'rare-legal-accessibility-policy' },
      meta: buildMetaTags('Rare RecruitmentPrivacy\'S Accessibility Policy.', 'Accessibility'),
    },
    {
      path: '/candidate-expenses-policy',
      name: 'CandidateExpensesPolicy',
      component: RareLegalPageWrapper,
      props: { header: 'Candidate Expenses Policy', content: 'rare-legal-candidate-expenses-policy' },
      meta: buildMetaTags('Rare Recruitment\'s Candidate Expenses Policy.', 'Candidate Expenses Policy'),
    },
    {
      path: '/faq',
      name: 'FAQ',
      component: RareLegalPageWrapper,
      props: { header: 'FAQs – Students', content: 'rare-legal-faq' },
      meta: buildMetaTags('Frequently asked questions', 'FAQ'),
    },
    {
      path: '/qualified-lawyers-faq',
      name: 'QualifiedLawyersFaq',
      component: RareLegalPageWrapper,
      props: { header: 'FAQs – Qualified Lawyers', content: 'rare-legal-qualified-lawyers-faq' },
      meta: buildMetaTags('Frequently asked questions', 'Qualified Lawyers FAQ'),
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
  mode: 'history',
});



// WEBPACK FOOTER //
// ./src/router/index.js